import styled from 'styled-components';

import { fontSizes, link } from 'ui/theme';

import { WorkflowIdData, WorkflowNodeCampaign, WorkflowTimestampData } from '../../../types';

const Link = styled.a`
  ${link};
  font-size: ${fontSizes.s14};
  line-height: ${fontSizes.s20};
`;

const getMessagingInsightsUrl = (
  campaigns: WorkflowNodeCampaign[],
  workflow: WorkflowIdData & WorkflowTimestampData,
) => {
  const messageMediums = [...new Set(campaigns.map(({ messageMedium }) => messageMedium)).values()];
  const searchParams = new URLSearchParams({
    messageMediums: messageMediums.sort().join(','),
    workflowIds: workflow.id.toString(),
    startTime: new Date(workflow.createdAt).toISOString(),
  });

  return `/messagingInsights?${searchParams.toString()}`;
};

type CampaignInsightsLinksProps = {
  workflow: WorkflowIdData & WorkflowTimestampData;
  campaigns: WorkflowNodeCampaign[];
};

export const CampaignInsightsLinks = ({ campaigns, workflow }: CampaignInsightsLinksProps) => (
  <Link data-test="messaging-insights-link" href={getMessagingInsightsUrl(campaigns, workflow)}>
    View insights
  </Link>
);
